/* unplugin-vue-components disabled */import script from "./ArticleHandle.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticleHandle.vue?vue&type=script&lang=ts&setup=true"

import "./ArticleHandle.vue?vue&type=style&index=0&id=4c9c3c05&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9c3c05"]])

export default __exports__